module.exports = __webpack_public_path__ + "img/jeweller@2x.4ad99b6.jpg";